if (typeof GlobalSearch === 'undefined') GlobalSearch = {};

"use strict";

GlobalSearch.DELAY = 300;
GlobalSearch.LIMIT = 30;

GlobalSearch.Results = Backbone.Collection.extend({

    initialize: function(models, options) {
        this.query = options.query;
        this.limit = options.limit;
    },
    url: function() {
       var param = {
           q: this.query
       };
        if (this.limit) param.limit = this.limit;
       return Core.contextRoot + '/search?' + $.param(param);
    },
});

GlobalSearch.iconByType = {
    order: 'icon-book',
    job: 'icon-briefcase',
    route: 'icon-road',
    workreport: 'icon-check',
    user: 'icon-user',
    article: 'icon-gift',
    reservation: 'icon-time',
};

GlobalSearch.iconImageByType = {
    customer: '/img/icons/glyph/glyphicons_352_nameplate.png',
    group: '/img/icons/glyph/glyphicons_043_group.png',
    vehicle: '/img/icons/glyph/glyphicons_005_car.png',
    asset: '/img/icons/glyph/glyphicons_089_building.png',
};


GlobalSearch.mapResult = function (model) {
    var type = model.get('_type');
    var hit = {
        type: type,
        id: model.id,
        title: model.get('title') || model.get('name'),
        description: model.get('description'),
        iconClass: GlobalSearch.iconByType[type],
        iconImage: GlobalSearch.iconImageByType[type],
        href: '#' + type + 's/' + model.id,
    };
    if (model.get('location') && model.get('location').placeName)
        hit.address = model.get('location').placeName;
    else if (model.get('destinations')) {
        var destinations = model.get('destinations');
        if (destinations && destinations.length > 0) {
            var text;
            if (destinations.length == 1) {
                if (destinations[0].location)
                    text = destinations[0].location.placeName;
            } else {
                for (var i = 1; i < destinations.length; i++) {
                    var destination = destinations[i];
                    if (destination.location && destination.location.placeName) {
                        text = destination.location.placeName;
                        break;
                    }
                }
                if (destinations.length > 2 && text)
                    text += ' (+' + (destinations.length-2) + ')';
            }
            hit.address = text;
        }
    }
    switch (type) {
        case 'article':
            return _(hit).extend({
                title: model.get('description') || model.get('articleNo'),
                description: null,
                no: model.get('articleNo'),
                href: '#articles/' + model.id,
            });
        case 'customer':
            return _(hit).extend({
                no: model.get('customerNo'),
                address: (model.get('location') ? model.get('location').placeName || '' : ''),
                href: '#customers/' + model.id,
            });
        case 'asset':
            return _(hit).extend({
                no: model.get('assetNo'),
                description: (model.get('customerName') ? model.get('customerName') : ''),
                address: (model.get('location') ? model.get('location').placeName || '' : ''),
                state: model.get('state') ? i18next.t('assetState_' + model.get('state')) : null,
                stateClass: model.get('state') ? 'asset-state-' + model.get('state').toLowerCase() : null,
                href: '#assets/' + model.id,
            });
        case 'group':
            return _(hit).extend({
                href: '#group/' + model.id,
            });
        case 'user':
            var name = Formatting.longName(model.toJSON());
            return _(hit).extend({
                title: name,
                description: (model.get('userName') && model.get('userName') != name ? model.get('userName') + ' ' : '')
                    + (model.get('emailAddress') && model.get('emailAddress') != name ? model.get('emailAddress') + ' ' : '')
                    + (Core.client && Core.client.hasPermission('impersonate') && model.get('primaryGroupName') ? ' <span style="margin-left: 20px">' + model.get('primaryGroupName') + '</span>' : ''),
            });
        case 'vehicle':
            return _(hit).extend({
                no: model.get('registrationNumber'),
                href: '#assets/' + model.id,
            });
        case 'order':
            return _(hit).extend({
                date: model.get('startDate') ? Formatting.datePart(model.get('startDate')) : null,
                no: model.get('orderNo'),
                state: model.get('state') ? i18next.t('orderState_' + model.get('state')) : null,
                stateClass: model.get('state') ? 'order-state-' + model.get('state').toLowerCase() : null,
            });
        case 'route':
            return _(hit).extend({
                date: model.get('startTime') ? Formatting.datePart(model.get('startTime')) : null,
                state: i18next.t('jobState_' + model.get('state')),
                stateClass: model.get('state') ? 'job-state-' + model.get('state').toLowerCase() : null,
            });
        case 'job':
            var group = model.get('groupId') ? Core.client.groups.get(model.get('groupId')) : null;
            return _(hit).extend({
                date: model.get('startTime') ? Formatting.datePart(model.get('startTime')) : null,
                no: (group ? group.get('prefix') : "") + model.get('jobNo'),
                state: model.get('state') ? i18next.t('jobState_' + model.get('state')) : null,
                stateClass: model.get('state') ? 'job-state-' + model.get('state').toLowerCase() : null,
            });
        case 'workreport':
            var title = model.get('jobTitle') || '';
            if (model.get('userId') != Core.client.me.id) {
                var user = Core.client.users.get(model.get('userId'));
                if (user) {
                    if (title.length > 0) title += ' - ';
                    title += user.shortName();
                }
            }
            var group = model.get('groupId') ? Core.client.groups.get(model.get('groupId')) : null;
            return _(hit).extend({
                date: model.get('workDate') ? Formatting.datePart(model.get('workDate')) : null,
                no: (group && model.get('jobNo') ? group.get('prefix') : "") + model.get('jobNo'),
                title: title,
                href: '#reports/' + model.id,
            });
        case 'invoice':
            var title = i18next.t('invoice') + ' ' + (model.get('invoiceNo') || model.get('downstreamId') || '');
            if (model.get('customerName')) title += ' - ' + model.get('customerName');
            if (model.get('customerProjectName')) title += ': ' + model.get('customerProjectName');
            return _(hit).extend({
                date: model.get('invoiceDate') ? Formatting.datePart(model.get('invoiceDate')) : null,
                no: model.get('invoiceNo') || model.get('downstreamId'),
                title: title,
                href: '#invoicing/' + model.get('uuid'),
            });
        default:
            console.error('no global search mapping for ' + model.get('_type'));
            return hit;
    }
};

GlobalSearch.initialize = function() {
    GlobalSearch.hitTemplate = Core.template('globalsearch-hit-template');

    $('#show-global-search').click(function() {
        if (window.view && window.view.$('#global-search input').length > 0) {
            window.view.$('#global-search input').select().focus();
        } else {
            if ($('.navbar #global-search').length > 0 && location.hash.substring(1) != 'dashboard') {
                $('.not-global-search').hide();
                $('#global-search').fadeIn();
            }
            $('#global-search input').select().focus();
        }
        return false;
    });
    $('#cancel-global-search').click(function() {
        $('#global-search').hide();
        $('.not-global-search').fadeIn();
        $('#show-global-search').focus();
        return false;
    });
    $('#global-search input').keyup(function (event) {
        if (CoreUI.keyCode(event) == 27) {
            if ($(event.currentTarget).val())
                $(event.currentTarget).val('');
            else
                $('#cancel-global-search').click();
        }
    });
    $('#show-global-search').keypress(function (event) {
        if (event.ctrlKey || event.altKey || event.metaKey) return true;
        var str = String.fromCharCode(event.which);
        if (str && str.length > 0) {
            $('#show-global-search').click();
            $('#global-search input').val(str);
            return false;
        }
        return false;
    });

    $('#global-search input').typeahead({
        minLength: 2,
        items: GlobalSearch.LIMIT,

        source: function(query, callback) {
            if (query == GlobalSearch.query && $('#global-search .typeahead').is(':visible')) return;
            GlobalSearch.query = query;
            clearTimeout(GlobalSearch.requestTimeout);
            GlobalSearch.requestTimeout = setTimeout(function() {
                if (GlobalSearch.request) GlobalSearch.request.abort();
                $('#global-search .search-loading').fadeIn();
                var results = new GlobalSearch.Results([], { query: query, limit: GlobalSearch.LIMIT });
                GlobalSearch.results = results;
                GlobalSearch.request = results.fetch().success(function () {
                    var hits = [];
                    results.each(function (result) {
                        hits.push(JSON.stringify(GlobalSearch.mapResult(result)));
                    });
                    if (hits.length == 0) hits = [ JSON.stringify({
                        nohit: true
                    }) ];
                    callback(hits);
                }).error(function (response) {
                    if (response.status != 0) errorResponse(response.responseText);
                }).complete(function () {
                    var state = GlobalSearch.request.state();
                    if (state == 'resolved' || state == 'rejected') {
                        $('#global-search .search-loading').stop(true, true).hide();
                    }
                });
            }, GlobalSearch.DELAY);
        },

        sorter: function(data) {
            return data;
        },
        highlighter: function(json) {
            var hit = JSON.parse(json);
            setTimeout(function() { $('#global-search .typeahead').width(self.$('#global-search input').last().width() + 'px'); }, 0);
            if (hit.nohit) setTimeout(function() { $('#global-search .nohit').parents('li').removeClass('active').addClass('disabled'); }, 0);
            return GlobalSearch.hitTemplate(hit);
        },
        matcher: function(data) {
            return true;
        },
        updater: function(json) {
            var hit = JSON.parse(json);
            if (hit.href) {
                if (GlobalSearch.ctrlKey)
                    window.open(hit.href, '_blank');
                else
                    location.href = hit.href;
            }
            setTimeout(function() {
                $('#global-search input').val('');
                $('#cancel-global-search').click();
            }, 500);
            return hit.title;
        }
    });
};
